import { useDetectionsBuffer } from "@/services/buffer-controller";
import { Computed, observer } from "@legendapp/state/react";
import { Detection } from "./detection";

export const Detections = observer(() => {
  const detectionsBuffer = useDetectionsBuffer();
  const tracks = detectionsBuffer.getTracks();

  return (
    <Computed>
      {() => tracks.map((track) => <Detection key={track} trackId={track} />)}
    </Computed>
  );
});
